import React, {useEffect, useMemo, useState} from 'react';
import {Box, Checkbox, FormControlLabel, FormGroup, Switch, Typography} from '@mui/material';
import 'components/UI/Input/SearchInAllDatabases.css';
import T from 'i18n-react';
import {parseStringToJson} from "lib/utils/stringUtils";

const renderAonSubscription = (form, onSubscriptionChange, isDisabled, isChecked) => {
    const configuration = parseStringToJson(localStorage.getItem('configuration'));
    if (!configuration || configuration.subscriptions?.aonVis !== 'AVAILABLE') {
        return null;
    }

    return <FormControlLabel
        disabled={isDisabled || configuration.subscriptions?.aon !== 'AVAILABLE'}
        key={'aon'}
        control={<Checkbox name={'aon'}
                           value={'aon'}
                           checked={isChecked}
                           onChange={onSubscriptionChange}
                           inputProps={{form: form}}
        />}
        label={T.translate('vinQueryComponent.subscriptionsFraudcheck')}/>
}

const renderAvailableSubscription = (settings) => {
    const renderSubscription = (subscriptionSettings) => {
        return <FormControlLabel
            disabled={subscriptionSettings.disabled}
            key={subscriptionSettings.key}
            control={<Checkbox defaultChecked name={subscriptionSettings.key}
                               value={subscriptionSettings.key}
                               onChange={subscriptionSettings.onSubscriptionChange}
                               inputProps={{form: subscriptionSettings.form}}
            />}
            label={subscriptionSettings.translation}/>
    }

    if (settings.visibilityKey === 'AVAILABLE') {
        const subscriptionSettings = {
            disabled: settings.isDisabled,
            value: settings.value,
            translation: settings.value,
            onSubscriptionChange: settings.onSubscriptionChange,
            form: settings.form,
            key: settings.key,
            isChecked: !!settings.isChecked,
        };
        return renderSubscription(subscriptionSettings);
    } else {
        return null;
    }
};

const renderSubscriptions = (form, onSubscriptionChange) => {
    const configuration = parseStringToJson(localStorage.getItem('configuration'));
    if (!configuration) {
        return [];
    }

    const subs = [];

    subs.push(renderAvailableSubscription({
        visibilityKey: configuration.subscriptions?.ahiAbroadVis,
        isDisabled: configuration.subscriptions?.ahiAbroad !== 'AVAILABLE',
        value: T.translate('vinQueryComponent.subscriptionsAhiAbroad'),
        onSubscriptionChange: onSubscriptionChange,
        key: 'ahiAbroad',
        form: form,
    }));

    subs.push(renderAvailableSubscription({
        visibilityKey: configuration.subscriptions?.ahiLocalVis,
        isDisabled: configuration.subscriptions?.ahiLocal !== 'AVAILABLE',
        value: T.translate('vinQueryComponent.subscriptionsAhiLocal', {country: T.translate(`vinSearchReducer.${configuration.country.toLowerCase()}`)}),
        onSubscriptionChange: onSubscriptionChange,
        key: 'ahiLocal',
        form: form,
    }));

    subs.push(renderAvailableSubscription({
        visibilityKey: configuration.subscriptions?.ahiUsaVis,
        value: T.translate('vinQueryComponent.subscriptionsAhiUsa'),
        key: 'ahiUsa',
        onSubscriptionChange: onSubscriptionChange,
        isDisabled: configuration.subscriptions?.ahiUsa !== 'AVAILABLE',
        form: form,
    }));

    return subs;
};

const SearchInAllDatabases = ({
                                  onSelectDatabasesManually,
                                  vinFieldValue,
                                  isDatabasesSwitchChecked,
                                  setIsDatabasesSwitchChecked,
                                  engineCC,
                                  year,
                                  form,
                              }) => {


    const yearNotEmpty = year != null;
    const engineNotEmpty = engineCC !== undefined && engineCC !== '';
    const vinNotEmpty = vinFieldValue !== undefined && vinFieldValue !== '';

    const defaultDatabases = useMemo(() => ['ahiAbroad', 'ahiLocal', 'ahiUsa'], []);
    const [selectedDatabases, setSelectedDatabases] = useState(defaultDatabases);
    const [isFraudcheckChecked, setIsFraudcheckChecked] = useState(false);

    const selectDatabaseHandler = event => {
        const selectedDatabase = event.target.value;
        setSelectedDatabases(prevState => {
            if (prevState.includes(selectedDatabase)) {
                return prevState.filter(db => db !== selectedDatabase);
            } else {
                return [...prevState, selectedDatabase];
            }
        });
    };
    useEffect(() => {
        if (isDatabasesSwitchChecked) {
            onSelectDatabasesManually(defaultDatabases);
            setSelectedDatabases(defaultDatabases);
        } else {
            onSelectDatabasesManually(selectedDatabases);
        }
    }, [selectedDatabases, onSelectDatabasesManually, isDatabasesSwitchChecked, defaultDatabases]);

    useEffect(() => {
        if ((yearNotEmpty && engineNotEmpty && vinNotEmpty)) {
            setIsFraudcheckChecked(prevState => !prevState)
        } else {
            setIsFraudcheckChecked(false)
        }
    }, [engineNotEmpty, vinNotEmpty, yearNotEmpty]);

    const toggleHandler = () => {
        setIsDatabasesSwitchChecked(prevState => !prevState);
    };

    const selectFraudcheck = (event) => {
        setIsFraudcheckChecked(prevState => !prevState)
        selectDatabaseHandler(event)
    }

    return (
        <>
            <Box sx={{
                display: 'flex',
                gap: 1,
            }}>
                <Typography component={'label'}>
                    <span>{T.translate("vinQueryComponent.databasesSwitch")}</span>
                    <Switch onChange={toggleHandler} checked={isDatabasesSwitchChecked}/>
                </Typography>
            </Box>
            <div className={`databasesForm ${isDatabasesSwitchChecked ? 'inactive' : 'active'}`}>
                <FormGroup className="dropdown-subscriptions">
                    {renderSubscriptions(form, selectDatabaseHandler)}
                    {renderAonSubscription(form, selectFraudcheck, !(yearNotEmpty && engineNotEmpty && vinNotEmpty), isFraudcheckChecked)}
                </FormGroup>
            </div>
        </>
    );
};

export default SearchInAllDatabases;
